import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import AccessArrangements from '../../modules/accessArrangment/components/candidate/AccessArrangements/AccessArrangements';

const AccessArrangementsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('accessArrangement->>AccessArrangements.TitleHeader')} />
      <AccessArrangements />
    </>
  );
};

export default AccessArrangementsPage;
